import { AxiosResponse } from 'axios';
import { HttpMethods } from "../httpMethods";
import { BotApplicationInstance } from "../../types/botApplicationInstance";
import { ApiBotApplicationInstances } from ".";
import { Controllers, BotApplicationInstanceApiRoutes, GeneralRoutes, CommonApiRoutes } from "../../utils/constants";
import { BaseService } from "../baseService";

export class BotApplicationInstanceService extends BaseService implements ApiBotApplicationInstances {
    async getAppInstanceById(appInstanceId: string): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Get, Controllers.ApplicationInstance, '', `${appInstanceId}`);
    }

    async getAppInstances(urlParams: string): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Get, Controllers.ApplicationInstance, BotApplicationInstanceApiRoutes.ApplicationInstances, urlParams);
    }

    async getAllBotApplicationInstances(): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Get, Controllers.ApplicationInstance, BotApplicationInstanceApiRoutes.AllApplicationInstances);
    }

    async createBotApplicationInstance(data: BotApplicationInstance): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Post, Controllers.ApplicationInstance, GeneralRoutes.Create, null, data);
    }

    async updateBotApplicationInstance(data: BotApplicationInstance): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Post, Controllers.ApplicationInstance, GeneralRoutes.Update, null, data);
    }

    async deleteBotApplicationInstance(data: string[]): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Post, Controllers.ApplicationInstance, GeneralRoutes.Delete, null, data);
    }

    async getAssignToData(): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Get, Controllers.ApplicationInstance, CommonApiRoutes.AssignedToData, null);
    }

    async importBotApplicationInstance(data: BotApplicationInstance[]): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Post, Controllers.ApplicationInstance, BotApplicationInstanceApiRoutes.Import, null, data);
    }
}